import { lodash } from 'helpers';
import { formatDecimalValue } from 'libs/form/fields/DecimalField/helpers';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { MAX_FLOATING_POINTS } from 'modules/account/orderModule/common/constants';

import { DirectoryAutocompleteField } from '../../../../../common/features';
import { Field, useFormContext } from '../../../forms/orderForm';
import { OrderSection } from '../../OrderSection';

import { useTransferVolumeSection } from './useTransferVolumeSection';

export const TransferVolumeSection = () => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const {
    isDisabledPrice,
    isRequiredPrice,
    isDisabledTransactionAmount,
    currencies,
    nominalQuantity,
  } = useTransferVolumeSection();

  return (
    <OrderSection
      fields={lodash.compact([
        <Field.Quantity
          fullWidth
          showRequiredMark
          label={t(
            'account.order.sections.transferVolumeSection.fields.quantity.label'
          )}
          minNumber={1}
          name="transferVolume.quantity"
          placeholder={t(
            'account.order.sections.transferVolumeSection.fields.quantity.placeholder'
          )}
        />,
        <Input
          fullWidth
          readOnly
          disabled={!readOnly}
          label={t(
            'account.order.sections.transferVolumeSection.fields.nominalQuantity.label'
          )}
          name="transferVolume.nominalQuantity"
          value={formatDecimalValue(nominalQuantity, MAX_FLOATING_POINTS, 0)}
        />,
        <Field.Decimal
          fullWidth
          disabled={readOnly ? false : isDisabledPrice}
          label={t(
            'account.order.sections.transferVolumeSection.fields.unitPrice.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          name="transferVolume.unitPrice"
          placeholder={
            isDisabledPrice
              ? undefined
              : t(
                  'account.order.sections.transferVolumeSection.fields.unitPrice.placeholder'
                )
          }
          showRequiredMark={isRequiredPrice}
        />,

        <DirectoryAutocompleteField<{ value: string; label: string }, false>
          key={`currency-field-${isDisabledPrice}`}
          fullWidth
          directorySchemaName={currencies.currency.directorySchemaName}
          disabled={readOnly ? false : isDisabledPrice}
          fieldName={currencies.currency.fieldName}
          label={t(
            'account.order.sections.transferVolumeSection.fields.currency.label'
          )}
          name="transferVolume.currency"
          placeholder={
            !isDisabledPrice
              ? t(
                  'account.order.sections.transferVolumeSection.fields.currency.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredPrice}
        />,

        <Field.Decimal
          fullWidth
          disabled={readOnly ? false : isDisabledTransactionAmount}
          label={t(
            'account.order.sections.transferVolumeSection.fields.transactionAmount.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          maxIntegerLength={0}
          name="transferVolume.transactionAmount"
          placeholder={
            !isDisabledPrice
              ? t(
                  'account.order.sections.transferVolumeSection.fields.transactionAmount.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredPrice}
        />,
      ])}
      title={t('account.order.sections.transferVolumeSection.title')}
    />
  );
};
